import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericService } from '../generics/generic.service';
import { Aerodromo } from 'src/app/model/geral/aerodromo';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})

@AutoRegisterService()
export class AerodromoService extends GenericService<Aerodromo> {
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("aerodromo")
  }
}
